import { render, staticRenderFns } from "./Shirt.vue?vue&type=template&id=6526b9ea&scoped=true"
import script from "./Shirt.vue?vue&type=script&lang=js"
export * from "./Shirt.vue?vue&type=script&lang=js"
import style0 from "./Shirt.vue?vue&type=style&index=0&id=6526b9ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6526b9ea",
  null
  
)

export default component.exports